'use client';

import React, { useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { Banner } from 'components/landing';
import { PlayWhite } from 'assets/icons';
import { useRingProVideoModal } from 'components/ring-pro/RingProVideoModal';
import styles from './VideoSection.module.css';

const VIDEO_PREVIEW = {
  web: 'web_v2/ring-pro/landing-page/videos/ring-pv-web.mp4/w_1920',
  mobile: 'web_v2/ring-pro/landing-page/videos/ring-pv-mob.mp4/w_1080',
};

/* ── Component ──────────────────────────────────────────── */

const VideoSection: React.FC = () => {
  const t = useTranslations('ring-pro');
  const wrapperRef = useRef<HTMLDivElement>(null);
  const bannerVideoRef = useRef<HTMLVideoElement | null>(null);
  const { openVideoModal } = useRingProVideoModal({ bannerVideoRef });

  useEffect(() => {
    const findVideo = () => {
      if (wrapperRef.current) {
        const el = wrapperRef.current.querySelector('video');
        if (el) bannerVideoRef.current = el;
      }
    };
    findVideo();
    const timeout = setTimeout(findVideo, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div ref={wrapperRef} id="video-section" className={styles.sectionWrapper}>
      <Banner
        background={{
          type: 'video',
          src: {
            web: VIDEO_PREVIEW.web,
            mobile: VIDEO_PREVIEW.mobile,
          },
          autoPlay: true,
          loop: true,
          muted: true,
          playsInline: true,
          visibilityThreshold: 0.1,
        }}
        sectionStyles={{ height: '100%' }}
        aria-label={t('ring-pro.video.ariaLabel')}
      />

      <div className={styles.contentOverlay}>
        <h2 className={styles.heading}>{t('ring-pro.video.heading')}</h2>
        <button
          className={styles.watchButton}
          onClick={openVideoModal}
          aria-label={t('ring-pro.common.watchVideo')}
          type="button"
        >
          <PlayWhite />
          {t('ring-pro.common.watchVideo')}
        </button>
      </div>
    </div>
  );
};

export default VideoSection;
